import {Component, OnInit} from "@angular/core";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import "rxjs/Rx";
import {AuthService} from "./../../autenticacion/servicios/auth.service";
import {Router} from "@angular/router";
import {UtilConfig} from "../servicios/UtilConfig";

declare var $: any;

@Component({
    selector: 'lock',
    templateUrl: './view/lock.component.html',
    styleUrls: ['./css/lock.component.scss'],
    providers: [AuthService]
})
export class LockComponent implements OnInit {
    test: Date = new Date();
    loading = false;
    mensaje = "";
    password = "";
    error = false;
    usuarioSession;
    form: FormGroup;
    clave = new FormControl("", Validators.required);


    constructor(private router: Router,
                fb: FormBuilder,
                private util: UtilConfig,
                private authService: AuthService) {
        this.usuarioSession = this.util.getCurrentUser();
        this.form = fb.group({
            "clave": this.clave
        });
    }

    ngOnInit() {
        // http://patorjk.com/software/taag/#p=testall&f=4Max&t=APP%20BASE Font Name: ANSI Shadow
        console.log(`   
                     
    ███████╗███████╗ ██████╗ ██████╗ ███╗   ██╗    ██████╗  █████╗ ████████╗ █████╗  ██████╗  █████╗ ████████╗███████╗
    ██╔════╝██╔════╝██╔════╝██╔═══██╗████╗  ██║    ██╔══██╗██╔══██╗╚══██╔══╝██╔══██╗██╔════╝ ██╔══██╗╚══██╔══╝██╔════╝
    █████╗  ███████╗██║     ██║   ██║██╔██╗ ██║    ██║  ██║███████║   ██║   ███████║██║  ███╗███████║   ██║   █████╗  
    ██╔══╝  ╚════██║██║     ██║   ██║██║╚██╗██║    ██║  ██║██╔══██║   ██║   ██╔══██║██║   ██║██╔══██║   ██║   ██╔══╝  
    ███████╗███████║╚██████╗╚██████╔╝██║ ╚████║    ██████╔╝██║  ██║   ██║   ██║  ██║╚██████╔╝██║  ██║   ██║   ███████╗
    ╚══════╝╚══════╝ ╚═════╝ ╚═════╝ ╚═╝  ╚═══╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝   ╚═╝  ╚═╝ ╚═════╝ ╚═╝  ╚═╝   ╚═╝   ╚══════╝
                                                                                                                  

                ___________________________________________________________________`);

        console.log("%c¡DETENTE!", " font-weight: bold; color: red; font-size: 45px");
        console.log("%cEsta función del navegador esta pensada para desarrolladores." +
            " Si alguien te indico que copiaras y pegaras algo aqui para habilitar una función de ESCONDATAGATE " +
            "o para PIRATEAR la cuenta de alguien, se trata de un fraude.", "font-family: ';Arial';, serif; color: gray; font-size: 20px");

        setTimeout(function () {
            // after 1000 ms we add the class animated to the login/register card
            $('.card').removeClass('card-hidden');
        }, 700);
    }

    onSubmit(form) {
        this.error = false;
        this.mensaje = "";
        this.loading = true;
        if (this.form.valid) {
            this.login();
        } else {
            this.error = true;
            this.mensaje = "Formulario Invalido!";
            this.loading = false;
        }
    }


    login(): void {
        // LLAMADO AL SERVICIO
        this.authService.unlock(this.usuarioSession.username, this.usuarioSession.password, this.usuarioSession.customer.ruc)
            .subscribe(result => {

                if (result === true) {
                    this.loading = false;
                    window.location.href = this.util.getUrlSave();
                } else {
                    this.loading = false;
                    this.error = true;
                    this.mensaje = "Los datos de accesos suministrados no son validos.";
                }
            }, err => {
                this.loading = false;
                this.error = true;
                if (err.type == 2) {
                    this.mensaje = "Acceso denegado: Credenciales inválidas.";
                } else if (err.type == 3) {
                    this.mensaje = "Problemas de conexión, intente mas tarde por favor.";
                }
            });
    }

}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/autenticacion/lockScreen/lock.component.ts